const applicationEnvironments = {
    prod: "ypoconnect.org",
    prodV: "prodvnext.ypoconnect.org",
    test: "test.ypoconnect.org",
    staging: "staging.ypoconnect.org",
};

const prodVariables = {
    CHAPTER_MANAGER_COMMUNICATIONS: "https://www.ypoconnect.org/#/group/ff475a38-8413-4a6a-b678-68016cd73a47",
    CHAPTER_MANAGEMENT_TOOLKIT: "https://connect.ypowpo.org/Portal/department/chapters-and-regions/toolkit/chapter-manager-toolkit",
    CHAPTER_WAIVERS: `${window.location.origin}/#/chapterWaiver/`,
    BUSINESS_MARKETPLACE_COMMUNITY_ID: '30303134-4d30-3030-3032-4433314b6500',
    BUSINESS_MARKETPLACE_COMMUNITY_URL: 'https://connect.ypowpo.org/portal/department/networks-and-groups/training-and-tools/business-marketplace-terms-and-conditions',
    REGIONAL_REDIRECT_SSO_URL: 'https://ypoportal.force.com/ypoconnect/s/',
    REFER_YPO_MEMBER: 'https://www.ypo.org/refer/',
    CREATE_NEW_EVENT_UPDATED_URL: 'https://events.app.cvent.com/events/creation/options',
    CODE_OF_CONDUCT: 'https://www2.ypoconnect.org/topics/24644/page/code-of-conduct',
    SPEAKER_SEARCH: 'https://yporesourcedirectory.ypo.org',
    BECOME_A_CFF: 'https://image.ypo-mail.org/lib/fe2f1171716404787c1478/m/1/82f873dc-4c94-4182-b6d7-4e8483f454a1.pdf',
    BLOB_CDN_END_POINT: process.env.VUE_APP_BLOB_URL || 'https://res.cloudinary.com/ypoconnect-prod',
    REFER_MEMBER: 'https://www.ypo.org/refer/',
    YPO_STORE: 'https://www.shopgenumark.com/ypo/',
    LEARNING_HUB: 'https://ypolearninghub.org/',
    MEMBER_BENEFITS: 'https://www2.ypoconnect.org/topics/17575/page/benefit-partner',
    CONCIERGE: `${window.location.origin}/#/concierge`,
    FORUM_TOOLKIT_DEPARTMENT_PAGE: 'https://connect.ypowpo.org/portal/department/forum/toolkit/forum-toolkit-welcome',
    FULL_MEMBER_DIRECTORY: 'https://ypo.my.site.com/memberdirectory/',
    FORUM_HUB: 'https://ypo.my.site.com/ypoforum',
    BECOME_A_CHAMPION: 'https://oegeek.my.canva.site/become-a-ypo-champion',
    VUE_APP_YPO_M2MX_ASSISTANCE_URL: 'https://ypo.my.site.com/ypoconcierge/s/request-assistance?type=m2mx',
    VUE_APP_YPO_SF_ASSISTANCE_URL: 'https://ypo.my.site.com/ypoconcierge/login?so=00D610000006Kr7',
};

const testVariables = {
    CHAPTER_MANAGER_COMMUNICATIONS: "https://www.ypoconnect.org/#/group/ff475a38-8413-4a6a-b678-68016cd73a47",
    CHAPTER_MANAGEMENT_TOOLKIT: "https://connect.ypowpo.org/Portal/department/chapters-and-regions/toolkit/chapter-manager-toolkit",
    CHAPTER_WAIVERS: `${window.location.origin}/#/chapterWaiver/`,
    BUSINESS_MARKETPLACE_COMMUNITY_ID: '30303134-4d30-3030-3032-4433314b6500',
    BUSINESS_MARKETPLACE_COMMUNITY_URL: 'https://psconnect.ypowpo.org/portal/department/networks-and-groups/training-and-tools/business-marketplace-terms-and-conditions',
    REGIONAL_REDIRECT_SSO_URL: 'https://ypo--qa.sandbox.my.site.com/ypoconnect/s/',
    REFER_YPO_MEMBER: 'https://www.ypo.org/refer/',
    CREATE_NEW_EVENT_UPDATED_URL: 'https://events.app.cvent.com/events/creation/options',
    CODE_OF_CONDUCT: 'https://www2.ypoconnect.org/topics/24644/page/code-of-conduct',
    SPEAKER_SEARCH: 'https://yporesourcedirectory.ypo.org',
    BECOME_A_CFF: 'https://image.ypo-mail.org/lib/fe2f1171716404787c1478/m/1/82f873dc-4c94-4182-b6d7-4e8483f454a1.pdf',
    BLOB_CDN_END_POINT: process.env.VUE_APP_BLOB_URL || 'https://res.cloudinary.com/ypoconnect-test',
    REFER_MEMBER: 'https://www.ypo.org/refer/',
    YPO_STORE: 'https://www.shopgenumark.com/ypo/',
    LEARNING_HUB: 'https://ypolearninghub.org/',
    MEMBER_BENEFITS: 'https://www2.ypoconnect.org/topics/17575/page/benefit-partner',
    CONCIERGE: `${window.location.origin}/#/concierge`,
    FORUM_TOOLKIT_DEPARTMENT_PAGE: prodVariables.FORUM_TOOLKIT_DEPARTMENT_PAGE,
    FULL_MEMBER_DIRECTORY: 'https://ypo--qa.sandbox.my.site.com/memberdirectory',
    FORUM_HUB: 'https://ypo--qa.sandbox.my.site.com/ypoforum/',
    BECOME_A_CHAMPION: 'https://oegeek.my.canva.site/become-a-ypo-champion',
    VUE_APP_YPO_M2MX_ASSISTANCE_URL: 'https://ypo--qa.sandbox.my.site.com/ypoconcierge/s/request-assistance?type=m2mx',
    VUE_APP_YPO_SF_ASSISTANCE_URL: 'https://qa-ypoportal.cs159.force.com/ypoconcierge',
};

const stagingVariables = {
    CHAPTER_MANAGER_COMMUNICATIONS: "https://www.ypoconnect.org/#/group/ff475a38-8413-4a6a-b678-68016cd73a47",
    CHAPTER_MANAGEMENT_TOOLKIT: "https://connect.ypowpo.org/Portal/department/chapters-and-regions/toolkit/chapter-manager-toolkit",
    CHAPTER_WAIVERS: `${window.location.origin}/#/chapterWaiver/`,
    BUSINESS_MARKETPLACE_COMMUNITY_ID: '30303134-4d30-3030-3032-4433314b6500',
    BUSINESS_MARKETPLACE_COMMUNITY_URL: 'https://psconnect.ypowpo.org/portal/department/networks-and-groups/training-and-tools/business-marketplace-terms-and-conditions',
    REGIONAL_REDIRECT_SSO_URL: 'https://ypo--uat.sandbox.my.site.com/ypoconnect/s/',
    REFER_YPO_MEMBER: 'https://www.ypo.org/refer/',
    CREATE_NEW_EVENT_UPDATED_URL: 'https://events.app.cvent.com/events/creation/options',
    CODE_OF_CONDUCT: 'https://www2.ypoconnect.org/topics/24644/page/code-of-conduct',
    SPEAKER_SEARCH: 'https://yporesourcedirectory.ypo.org',
    BECOME_A_CFF: 'https://image.ypo-mail.org/lib/fe2f1171716404787c1478/m/1/82f873dc-4c94-4182-b6d7-4e8483f454a1.pdf',
    BLOB_CDN_END_POINT: process.env.VUE_APP_BLOB_URL || 'https://res.cloudinary.com/ypoconnect-staging',
    REFER_MEMBER: 'https://www.ypo.org/refer/',
    YPO_STORE: 'https://www.shopgenumark.com/ypo/',
    LEARNING_HUB: 'https://ypolearninghub.org/',
    MEMBER_BENEFITS: 'https://www2.ypoconnect.org/topics/17575/page/benefit-partner',
    CONCIERGE: `${window.location.origin}/#/concierge`,
    FORUM_TOOLKIT_DEPARTMENT_PAGE: prodVariables.FORUM_TOOLKIT_DEPARTMENT_PAGE,
    FULL_MEMBER_DIRECTORY: 'https://ypo--uat.sandbox.my.site.com/memberdirectory/',
    FORUM_HUB: 'https://ypo--uat.sandbox.my.site.com/ypoforum/',
    BECOME_A_CHAMPION: 'https://oegeek.my.canva.site/become-a-ypo-champion',
    VUE_APP_YPO_M2MX_ASSISTANCE_URL: 'https://ypo--uat.sandbox.my.site.com/ypoconcierge/s/request-assistance?type=m2mx',
    VUE_APP_YPO_SF_ASSISTANCE_URL: 'https://ypo--uat.sandbox.my.site.com/ypoconcierge/login?so=00D020000008lEz',
};


export const commonEnvVariables = () => {
    const currentEnv = window.location.host;
    let envVariables = testVariables;
    if (currentEnv === applicationEnvironments.prod || currentEnv === `www.${applicationEnvironments.prod}`) envVariables = prodVariables;
    if (currentEnv === applicationEnvironments.prodV || currentEnv === `www.${applicationEnvironments.prodV}`) envVariables = prodVariables;
    if (currentEnv === applicationEnvironments.staging || currentEnv === `www.${applicationEnvironments.staging}`) envVariables = stagingVariables;
    return envVariables;
};
